module.exports = __webpack_public_path__ + "static/media/pageup.8340b3cb.svg";